import { render, staticRenderFns } from "./NsInput.vue?vue&type=template&id=76262fec&scoped=true&"
import script from "./NsInput.vue?vue&type=script&lang=js&"
export * from "./NsInput.vue?vue&type=script&lang=js&"
import style0 from "./NsInput.vue?vue&type=style&index=0&id=76262fec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76262fec",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NsIcon: require('/usr/app/src/components/ns/NsIcon.vue').default})
